import { ABOVE_THE_FOLD_RATING_CONTAINER, REVIEWS_SECTION_ID } from '../../classnames/reviews';

export default class RatingClickHandler {
  ratingContainer = document.querySelector(`.${ABOVE_THE_FOLD_RATING_CONTAINER}`);
  reviewContainer = document.getElementById(REVIEWS_SECTION_ID);

  handleClick = () => {
    this.reviewContainer.scrollIntoView({ behavior: 'smooth' });
  };

  initializeEventListeners = () => {
    if (this.ratingContainer) {
      this.ratingContainer.addEventListener('click', this.handleClick);
    }
  };
}
